import fetch from '@/plugin/axios'

// 裂变列表
export function getFissionList (query) {
  return fetch({
    url: '/api/order/fission/list',
    method: 'Post',
    data: query
  })
}
// 裂变新增
export function getFissionadd (query) {
  return fetch({
    url: '/api/order/fission/add',
    method: 'Post',
    data: query
  })
}
// 裂变编辑
export function getFissionupdate (id, query) {
  return fetch({
    url: `/api/order/fission/update/${id}`,
    method: 'Post',
    data: query
  })
}
// 裂变详情
export function getFissioninfo (id) {
  return fetch({
    url: `/api/order/fission/info/${id}`,
    method: 'Get'
  })
}
// 下架活动
export function getFissiondown (id) {
  return fetch({
    url: `/api/order/fission/down/${id}`,
    method: 'Get'
  })
}
// 上架活动
export function getFissionup (id) {
  return fetch({
    url: `/api/order/fission/up/${id}`,
    method: 'Get'
  })
}
